/* eslint-disable no-undef */
import React, { Component } from "react";
import { connect } from "react-redux";
import SmsVerification from "./SmsVerification";
import ReactPixel from "react-facebook-pixel";
import { forgotPasswords, selectPassword } from "../../../state/ducks/password";
import $ from "jquery";
import LoginPageLoadingIndicator from "./LoginPageLoadingOverlay";
import LoginPageAlert from "./LoginPageAlert";
import { hideModal, selectAlertMessage } from "../../../state/ducks/alert";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import Inputmask from "inputmask";
import { applyLoginPageBody } from "./loginPageBody";
import LoginBrandPanel from "./LoginBrandPanel";

class ForgotPassword extends Component {
    state = {
        corporate: this.props.match.params.type === "corporate",
        corporateCss: "",
        kimlikNo: "",
        gsm: "",
        token: "",
        countryPhoneCode: "90",
    };

    maskAndRegexInput() {
        var tckimlikno = document.getElementById("tcKimlikNo");
        if (tckimlikno != null) {
            Inputmask({ regex: "[0-9]{11}" }).mask(tckimlikno);
        }
    }

    componentDidMount() {
        this.maskAndRegexInput();
        if (this.state.corporate === true) {
            this.setState({ corporateCss: "-krmsl" });
        }
        $(".react-datepicker-wrapper").addClass("form-control");
        applyLoginPageBody();
        ReactPixel.init("210664537388285");
        ReactPixel.pageView();
        this.createCaptchaToken();
    }

    submit = (event) => {
        event.preventDefault();
        this.props.hideModal();

        var _kimlikNo = this.state.kimlikNo.replace(/\D/g, '');
        var _countryPhoneCode = this.state.countryPhoneCode;
        const data = {
            kimlikNo: _kimlikNo,
            gsm: this.state.gsm,
            token: this.state.token,
            countryPhoneCode: _countryPhoneCode,
        };
        this.props.forgotPasswords(data);
        this.createCaptchaToken();
    };

    createCaptchaToken() {
        var that = this;
        grecaptcha.ready(function () {
            grecaptcha
                .execute("6LeiYdwUAAAAAFsmN76CLhs9VADdnPT4OnzKWCFT", {
                    action: "/Home",
                })
                .then((token) => {
                    that.setState({ token: token });
                });
        });
    }

    dismissAlert = () => {
        if (this.props.alert?.redirect) {
            this.props.history.push(this.props.alert.redirect);
        }
        this.props.hideModal();
    };

    render() {
        const { alert, password } = this.props;
        const isResetStep = password?.isOpen || password?.isOpenEposta;

        return (
                <div className="t-loginPage t-loginPage--split">
                    <LoginBrandPanel />

                    <main className="t-loginPage-main">
                        <LoginPageLoadingIndicator active={alert?.loading} subtext="İşleminiz gerçekleştiriliyor..." />
                        <div className="t-loginPage-mainScroll">
                            <div className="t-loginPage-mainInner">
                                <div className="t-loginPage-mainLogoWrap">
                                    <img
                                        src="/assets/img/svg/logo_internetSube-dark.svg"
                                        alt="Eminevim İnternet Şube"
                                        className="t-loginPage-mainLogo"
                                    />
                                </div>
                                {isResetStep ? (
                                    <>
                                        {alert?.isOpen && alert?.message ? (
                                            <LoginPageAlert
                                                messages={alert.message}
                                                type={alert.type === "success" ? "success" : "error"}
                                                onDismiss={this.dismissAlert}
                                            />
                                        ) : null}
                                        <SmsVerification />
                                    </>
                                ) : (
                                <form onSubmit={this.submit}>
                                    <header className="t-loginPage-head">
                                        <span className="t-loginPage-forgotIcon" aria-hidden="true">
                                            <i className="t-icon-phone1" />
                                        </span>
                                        <h1 className="t-loginPage-title">Anında Şifre Al</h1>
                                        <p className="t-loginPage-subtitle">Kimlik ve telefon bilgilerinizle şifrenizi sıfırlayın.</p>
                                    </header>

                                    {alert?.isOpen && alert?.message ? (
                                        <LoginPageAlert
                                            messages={alert.message}
                                            type={alert.type === "success" ? "success" : "error"}
                                            onDismiss={this.dismissAlert}
                                        />
                                    ) : null}

                                    <div className="t-loginPage-form">
                                        <div className="t-loginPage-field">
                                            <label className="t-loginPage-label" htmlFor="tcKimlikNo">TC Kimlik / VKN</label>
                                            <div className="t-resetPassword-inputWrap">
                                                <span className="t-resetPassword-inputIcon">
                                                    <i className="t-icon-account_box" aria-hidden="true" />
                                                </span>
                                                <input
                                                    type="text"
                                                    id="tcKimlikNo"
                                                    className="decimalnumber"
                                                    placeholder="TC Kimlik / VKN giriniz"
                                                    value={this.state.kimlikNo}
                                                    onChange={(e) => this.setState({ kimlikNo: e.target.value })}
                                                    maxLength={11}
                                                />
                                            </div>
                                        </div>

                                        <div className="t-loginPage-field">
                                            <label className="t-loginPage-label">GSM Numaranız</label>
                                            <div className="t-loginPage-phoneWrap">
                                                <PhoneInput
                                                    country="tr"
                                                    value={this.state.gsm}
                                                    placeholder="+90 500 000 00 00"
                                                    buttonStyle={{ border: "none", background: "transparent" }}
                                                    inputClass="new-phone-input"
                                                    inputProps={{ id: "telefonnumarasi" }}
                                                    countryCodeEditable={false}
                                                    onChange={(value, data) => {
                                                        this.setState({
                                                            gsm: value.replace(/\D/g, ''),
                                                            countryPhoneCode: data?.dialCode || "90",
                                                        });
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="t-loginPage-buttonRow">
                                            <a href="./giris" target="_parent" className="t-loginPage-backBtn">
                                                <i className="t-icon-arrow-left2" aria-hidden="true" />
                                                Geri Dön
                                            </a>
                                            <button type="submit" className="t-loginPage-submit">
                                                Devam Et
                                                <i className="t-icon-arrow-right2" aria-hidden="true" />
                                            </button>
                                        </div>
                                    </div>
                                </form>
                                )}
                            </div>
                        </div>
                    </main>
                </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        password: selectPassword(state),
        alert: selectAlertMessage(state)
    };
};

const mapDispatchToProps = (dispatch) => ({
    forgotPasswords: (data) => dispatch(forgotPasswords(data)),
    hideModal: () => dispatch(hideModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
